module.exports = __webpack_public_path__ + "img/tcv_driving.9c761be5.svg";